import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, ElectronService } from '@pos-app/core-ui';
import { KEYS } from '@pos-app/data';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-help-how-to',
  styleUrls: ['./help-how-to.component.scss'],
  templateUrl: './help-how-to.component.html',
})
export class HelpHowToComponent implements OnInit, OnChanges {
  @Input() helpHowToComponent: any;
  myHelpComponents: any;
  setIframeBaseUrlTimeout: boolean = false;
  unSubscribe$ = new Subject<void>();

  constructor(private router: Router, private apiService: ApiService, private cdr: ChangeDetectorRef, private electronService: ElectronService, private toastr: ToastrService) {}

  ngOnInit() {
    this.myHelpComponents = this.helpHowToComponent;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.helpHowToComponent?.currentValue) {
      this.myHelpComponents = changes.helpHowToComponent?.currentValue;
      this.cdr.detectChanges();
    }
  }

  setIframeBaseUrl(myHelpComponent: any) {
    if (this.setIframeBaseUrlTimeout) {
      return;
    } else if (!this.setIframeBaseUrlTimeout) {
      this.setIframeBaseUrlTimeout = true;
      setTimeout(() => {
        console.log('Setting iframe base url for myHelpComponent');
        const userProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
        localStorage.setItem(KEYS.jdeSession, JSON.stringify({ ...userProfile, iframeBaseUrl: myHelpComponent?.url }));
        //get base url of application
        const baseUrl = window.location.origin === 'http://localhost:4200' ? 'https://central-py.arb.com.au' : window.location.origin;
        if (myHelpComponent?.loadInNewTab) {
          this.navigateToExternalLink(myHelpComponent?.url);
          //get baseUrl from url
        } else if (!myHelpComponent?.loadInNewTab && myHelpComponent?.url.includes(baseUrl)) {
          const url = myHelpComponent?.url.split(baseUrl);
          if (url.length && url[1].includes('download/file/')) {
            const myId = url[1].split('download/file/')[1];
            this.openLink(myId);
          } else {
            this.router.navigateByUrl(url[1]);
          }
        } else {
          this.router.navigateByUrl(`/central/help-how-to/${myHelpComponent?.label}`);
        }
        this.setIframeBaseUrlTimeout = false;
      }, 1000);
    }
  }

  navigateToExternalLink(link: string) {
    window.open(link);
  }

  // Scroll the help component list to the right
  scrollRightb(): void {
    this.scrollHelpComponentList(500);
  }

  // Scroll the help component list to the left
  scrollLeftb(): void {
    this.scrollHelpComponentList(-500);
  }

  // Helper method to scroll the help component list
  private scrollHelpComponentList(offset: number): void {
    const element = document?.querySelector('.my-related-component-list') as HTMLElement;
    if (element) {
      element.scrollLeft += offset;
    }
  }

  private openLink(id: string, isOpeningAsUrl = false) {
    return this.apiService
      .getDownloadUrl(id, isOpeningAsUrl)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        this.toastr.success('File downloaded successfully');
        if (this.electronService.isElectron) {
          if (isOpeningAsUrl) {
            this.electronService.openLinkNatively(res.fileUrl);
          } else {
            this.electronService.openFileNatively(res.fileUrl);
          }
          return;
        }
        window.open(res.fileUrl, isOpeningAsUrl ? '_blank' : '_self');
      });
  }
}
